import { Link } from "react-router-dom"

const Footer = () => {
  const year = new Date().getFullYear()

  return (
    <footer className="border-t border-gallery-border mt-16 md:mt-24">
      <div className="gallery-container py-8">
        <div className="flex flex-col items-center gap-5 text-center sm:flex-row sm:justify-between sm:gap-6 sm:text-left">
          <p className="gallery-label text-gallery-muted">© {year} r4v3n LLC. All rights reserved.</p>

          <nav className="flex items-center gap-6" aria-label="Legal">
            <Link to="/terms" className="gallery-label text-gallery-muted hover:text-gallery-text transition-colors">
              Terms of Use
            </Link>
            <Link to="/privacy" className="gallery-label text-gallery-muted hover:text-gallery-text transition-colors">
              Privacy
            </Link>
          </nav>

          <a
            href="https://x.com/r4v3n_art"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="r4v3n on X"
            className="text-gallery-muted hover:text-gallery-text transition-colors"
          >
            <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.45-6.231Zm-1.161 17.52h1.833L7.084 4.126H5.117l11.966 15.644Z" />
            </svg>
          </a>
        </div>
      </div>
    </footer>
  )
}

export default Footer
